import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { ProfileService } from './profile.service'
import { ModalCropImageData } from './profile.reducer'

export const closeModalCropImage = createAction('profile/closeModalCropImage')
export const showModalCropImage = createAction<ModalCropImageData>('profile/showModalCropImage')

export const getProfessionalProfile = createAsyncThunk(
  'profile/getProfessionalProfile',
  ProfileService.getProfessionalProfile
)

export const updateProfessionalProfile = createAsyncThunk(
  'profile/updateProfessionalProfile',
  ProfileService.putProfessionalProfile
)

export const postProfessionalProfileImage = createAsyncThunk(
  'profile/postProfessionalProfileImage',
  ProfileService.postProfessionalProfileImage
)
